<template>
    <header>
        <div class="container-fluid">
            <nav class="navbar navbar-expand-lg navbar-light bg-light">
                <router-link :to="propRolRedirect" class="navbar-brand">
                    <img v-bind:src="`assets/img/logo.jpg`" class="img-fluid">
                </router-link>
                <button class="navbar-toggler" type="button" data-toggle="collapse"
                        data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                        aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">
                    <ul class="navbar-nav">
                        <li class="nav-item" v-if="avatars.logo">
                            <img v-bind:src="avatars.logo" style="width: 200px;" loading="lazy"
                                 class="img-fluid">
                        </li>
                        <li v-if="$store.getters['moduleTenants/tenants'].length > 0" class="nav-item">
                            <div class="select-switch-tenants">
                                <select v-model="modelTenants" class="form-control"
                                        v-on:change="onChangeSwitchTenants()">
                                    <option value=''>{{ $t('navbarMain.textSelectSwitchTenants') }}</option>
                                    <option v-for="(item, index) in $store.getters['moduleTenants/tenants']"
                                            :key="index"
                                            :value="item.hasOwnProperty('tenants_id') ? item.tenants_id:item.TID">{{
                                            item.hasOwnProperty('tenants_id') ?
                                                item.tenant_name.charAt(0).toUpperCase() + item.tenant_name.slice(1).toLowerCase()
                                                :
                                                item.razonSocial.charAt(0).toUpperCase() + item.razonSocial.slice(1).toLowerCase()
                                        }}
                                    </option>
                                </select>
                            </div>
                        </li>
                        <li class="block-dropdown-filter-main nav-item"></li>
                        <li class="block-dropdown-avatar nav-item dropdown">
                            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button"
                               data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <span class="e-avatar e-avatar-small e-avatar-circle"
                                      v-bind:style="`background-image: url('assets/img/user.png');`"></span>
                                {{ avatars.name }}
                            </a>
                            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                                <!-- Card Component -->
                                <div class="e-card e-custom-card">
                                    <div class="e-card-header">
                                        <div class="e-avatar e-avatar-circle e-avatar-xlarge"
                                             v-bind:style="`background-image: url('assets/img/user.png');`"></div>
                                    </div>
                                    <div class="e-card-header">
                                        <div class="e-card-header-caption center">
                                            <div class="e-card-header-title">{{ avatars.name }}</div>
                                            <div class="e-card-sub-title">{{ avatars.role }}</div>
                                            <div class="e-card-sub-title">{{ avatars.tenant }}</div>
                                        </div>
                                    </div>
                                    <div class="e-card-content">
                                        <button type="button" class="btn btn-outline-info btn-sm"
                                                @click.prevent="onChangePassword">{{ $t('navbarMain.password') }}
                                        </button>
                                        <button type="button" class="btn btn-outline-dark btn-sm"
                                                @click.prevent="onLogout">{{ $t('navbarMain.goOut') }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </li>

                        <li class="block-dropdown-avatar nav-item dropdown">
                            <a href="#" class="dropdown-toggle" data-toggle="dropdown"
                            title="Centro de Aprendizaje">
                                <span class="learning-center" style="display:inline-flex;align-items:center;justify-content:center;width:30px;height:30px;border-radius:50%;background-color: #e3165b;color:#fff;font-size:16px;font-weight:bold;line-height:1;">
                                    <svg focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="SchoolOutlinedIcon" fill="#e8e8e8" style="width: 23px;">
                                        <path d="M12 3 1 9l4 2.18v6L12 21l7-3.82v-6l2-1.09V17h2V9zm6.82 6L12 12.72 5.18 9 12 5.28zM17 15.99l-5 2.73-5-2.73v-3.72L12 15l5-2.73z"></path>
                                    </svg>
                                </span>
                            </a>
                            <ul class="dropdown-menu">
                                <li class="dropdown-header text-center border-bottom"><strong>Centro de Aprendizaje</strong></li>
                                <li>
                                    <a class="nav-link bg-light" style="height: 30px;" href="https://blog.legopstech.com/alinea" target="_blank" rel="noopener">
                                        <span class="e-input-group-icon e-search-icon e-icons" tabindex="-1" title="Explora" aria-label="Explora"></span> Explora
                                    </a>
                                </li>
                                <li>
                                    <a class="nav-link bg-light" style="height: 30px;" href="https://alinea.legopstech.com/centro-de-aprendizaje" target="_blank" rel="noopener">
                                        Academia
                                    </a>
                                </li>
                                <li>
                                    <a class="nav-link bg-light" style="height: 30px;" href="https://alinea.legopstech.com/centro-de-aprendizaje" target="_blank" rel="noopener">
                                        Preguntas y Respuestas
                                    </a>
                                </li>
                            </ul>
                        </li>

                        <li class="nav-item"><a class="nav-link btn-lang"
                                                @click.prevent="onChangeLang(!lang)">{{ (lang) ? 'ES' : 'EN' }}</a></li>
                    </ul>
                </div>
            </nav>
        </div>
        <session-expired></session-expired>
    </header>
</template>
<script>
import axios from 'axios';
import hubspotChat from '@src/services/hubspot-chat';

var itemVue = Vue.component("itemTemplate", {
    template: `
        <div class="itemFather">
        <div class='e-list-icon' :class='data.iconCss'></div>
        <div class='processText'>{{ data.name }}</div>
        </div>`,
    data() {
        return {
            data: {}
        };
    }
});

export default {
    name: 'navbar-main',
    props: {
        rol: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            lang: (I18n.locale === 'es'),
            filter: [],
            searchData: 0,
            fields: {value: 'name'},
            iTemplate: function (e) {
                return {
                    template: itemVue
                };
            },
            modelTenants: localStorage.getItem('TID'),
            listSwitchTenants: [],
            url: process.env.BASE_URL_API_BACK,
        }
    },
    computed: {
        avatars() {
            return this.$store.getters['moduleAvatar/avatar']
        },
        propRolRedirect() {
            switch (this.rol) {
                case 'Estructurador':
                    return {name: 'structuring-dashboard'};
                default:
                    return {name: 'dashboard'};
            }
        },
    },
    methods: {
        initNavbarMain: function () {
            axios.post('/auth/processes/getComplianceAndProcessesSearch').then(response => {
                this.searchData = response.data;
            });
        },
        onLogout: function () {
            // Limpiar la identificación del chat para no conservar la identidad anterior.
            hubspotChat.reset();
            this.$store.dispatch('moduleSession/destroyToken');
            this.$store.replaceState({});
            localStorage.removeItem('alinea');
            this.$router.push({name: 'login'});
            window.location.reload();
        },
        clearCheckboxFilter: function () {
            this.filter = [];
        },
        onChangeLang: function (args) {
            this.$store.dispatch('moduleSession/changeLang', { lang: (args) ? 'es' : 'en'})
            this.lang = args;
            I18n.locale = (args) ? 'es' : 'en';
        },
        selectProcess: function (args) {
            let process = args.itemData.process;
            document.getElementById("search").ej2_instances[0].value = null;
            if (args.itemData.iconCss === 'e-compliance-icon') {
                let compliance = args.itemData.compliance_id;
                this.$router.push({
                    name: 'processes-detail-compliance',
                    params: {'id': process, 'idCompliance': compliance}
                });
            } else {
                this.$router.push({name: 'processes-detail', params: {'id': process}});
                setTimeout(() => {
                    Vue.prototype.$eventHub.$emit('onGetTeamProcess');
                }, 250);
            }
        },
        onChangePassword: function () {
            Vue.prototype.$eventHub.$emit('toggleSidebarClick', 'Cambiar contraseña', 'password-change');
        },
        onChangeSwitchTenants: async function () {
          if (this.$store.getters['moduleAvatar/avatar'].role === 'Estructurador') {
                localStorage.setItem('TID', this.modelTenants);
                axios.defaults.headers.post['TID'] = this.modelTenants;
                Vue.prototype.$eventHub.$emit('onResetSwitchTenantsStructuring');
            } else {
                localStorage.setItem('TID', this.modelTenants);

                axios.defaults.headers.post['TID'] = this.modelTenants;

                await this.$store.dispatch('moduleSession/switchTenant', {
                    TID: this.modelTenants,
                    email: this.$store.getters['moduleAvatar/avatar'].email
                }).then(response => {
                    if (response.data.status === 'success') {
                        this.$store.dispatch('moduleAvatar/GET_AVATAR', JSON.parse(sessionStorage.getItem('avatar')));
                        sessionStorage.removeItem('avatar');
                        Vue.prototype.$eventHub.$emit('onHideSpinner');
                        switch (this.$route.name) {
                            case 'dashboard':
                            case 'structuring-dashboard':
                                location.reload();
                                break;
                            default:
                                Vue.prototype.$eventHub.$emit('onHideSpinner');
                                this.$router.push('/switchTenant');
                                break;
                        }
                    }
                }).catch(error => {
                    console.log(error)
                    if (error.response.status === 400) {
                        this.tenants = '';
                        this.validShowError = true;
                        this.validShowTenants = false;
                        Vue.prototype.$eventHub.$emit('onHideSpinner');
                        Vue.prototype.$eventHub.$emit('showToastNotification', this.$t('navbarMain.errorOnChangeTenant'));
                    }
                });
                Vue.prototype.$eventHub.$emit('onResetSwitchTenants');
            }
        },
    },
    created: function () {
        this.initNavbarMain();
    }
}
</script>
